export const mutations = {
    setContaPagar(state, data) {
        state.contaPagar = data
    },
    setContasPagar(state, data) {
        state.contasPagar = data
    },
    setContaPagarPermissoesSelecionadas(state, data){
        state.contaPagarPermissoesSelecionadas = data
    },
    addContaPagar(state, data){
        state.contasPagar.push(data)
    },
    removeContaPagar(state, data){
        let index = state.contasPagar.data.map(x => x.id).indexOf(data.id);
        state.contasPagar.data.splice(index, 1)
    },
    setModalCadastrarContaPagar(state, status) {
        state.modalCadastrarContaPagar = status
    },
    setModalExcluirContaPagar(state, status) {
        state.modalExcluirContaPagar = status
    },
    setModalBaixaContaPagar(state, status) {
        state.modalBaixaContaPagar = status
    },
    setShowInputAnexo(state, status){
        state.showInputAnexo = status
    }
    
}

export default {}